import { Eyebrow, Reveal } from './Reveal';

const INDUSTRIES = [
  {
    testid: 'industry-card-restaurants',
    name: 'Restaurants & Cafés',
    desc: 'Kitchen, service and operations',
    image: 'https://images.unsplash.com/photo-1622021142947-da7dedc7c39a?q=80&w=1200&auto=format&fit=crop',
    alt: 'Indian chef preparing food in a restaurant kitchen',
  },
  {
    testid: 'industry-card-catering',
    name: 'Corporate Catering',
    desc: 'Food service and deployment teams',
    image: 'https://images.unsplash.com/photo-1583338917496-7ea264c374ce?q=80&w=1200&auto=format&fit=crop',
    alt: 'Indian catering team serving a corporate buffet',
  },
  {
    testid: 'industry-card-events',
    name: 'Events & Exhibitions',
    desc: 'Temporary operational support',
    image: 'https://images.unsplash.com/photo-1512061942530-e6a4e9a5cf27?q=80&w=1200&auto=format&fit=crop',
    alt: 'Indian event staff preparing a banquet venue',
  },
  {
    testid: 'industry-card-retail',
    name: 'Retail & Services',
    desc: 'Customer-facing and support roles',
    image: null,
    alt: '',
  },
];

export default function Industries() {
  return (
    <section id="who-we-support" data-testid="industries-section" className="scroll-mt-28 bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow index="08">Who we support</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
              Workforce expertise for <span className="text-royal">real business needs.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg">
              Our solutions support operational and professional staffing requirements across service-oriented
              industries.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.testid} delay={i * 0.1} className="h-full">
              <article
                data-testid={ind.testid}
                className={`group relative h-full overflow-hidden rounded-[1.75rem] shadow-card transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 hover:shadow-lift ${
                  ind.image ? '' : 'aspect-[3/4] bg-royal-ink'
                }`}
              >
                {ind.image ? (
                  <>
                    <img
                      src={ind.image}
                      alt={ind.alt}
                      loading="lazy"
                      className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                    <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-royal-ink/85 via-royal-ink/20 to-transparent" />
                  </>
                ) : (
                  <span aria-hidden="true" className="pointer-events-none absolute -right-3 top-0 font-display text-[120px] font-extrabold leading-none text-outline-light">
                    0{i + 1}
                  </span>
                )}
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <span aria-hidden="true" className="mb-3 inline-block h-1 w-10 rounded-full bg-lime transition-[width] duration-300 group-hover:w-16" />
                  <h3 className="font-display text-lg font-extrabold text-white">{ind.name}</h3>
                  <p className="mt-1 text-[13px] font-semibold text-white/70">{ind.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
